<div class="container">

    <app-header></app-header>
    
    <div class="content">
        <router-outlet></router-outlet>
    </div>

    
    <!-- without the footer, .content fills the viewport so the loading state takes the whole page -->
    <!-- hidden (not destroyed) while loading: .content fills the viewport and the footer keeps its DOM (top.ge counter) -->
   <!-- @if (!isPageLoading()) {
      <app-layout-footer [style.display]="isPageLoading() ? 'none' : null"></app-layout-footer>
   } -->

    @if (!isPageLoading()) {
        <app-layout-footer></app-layout-footer>
    }
</div>
